module.exports = __webpack_public_path__ + "static/assets/fbcc6e1cf49cba3f5a94daabad30f7e9.svg";